(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbg-design-filter"] && !Shopify.designMode) return;
  try {
    class BbgDesignFilter extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.updateLink);
      this.addEventListener('auxclick', this.updateLink);
      this.addEventListener('contextmenu', this.updateLink);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.updateLink);
      this.removeEventListener('auxclick', this.updateLink);
      this.removeEventListener('contextmenu', this.updateLink);
    }

    updateLink = (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-bbg-design-link]');
      if (!(link instanceof HTMLAnchorElement)) return;

      const destination = new URL(link.href, window.location.origin);
      const current = new URL(window.location.href);
      const form = this.closest('form');
      const source = form ? new FormData(form) : current.searchParams;

      for (const key of [...destination.searchParams.keys()]) {
        if (key.startsWith('filter.')) destination.searchParams.delete(key);
      }

      for (const [key, value] of source.entries()) {
        if (typeof value !== 'string' || value === '') continue;
        if (key.startsWith('filter.')) destination.searchParams.append(key, value);
        if (key === 'sort_by') destination.searchParams.set(key, value);
      }

      if (!destination.searchParams.get('sort_by') && current.searchParams.has('sort_by')) {
        destination.searchParams.set('sort_by', current.searchParams.get('sort_by'));
      }
      if (current.searchParams.has('preview_theme_id')) {
        destination.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      }
      const mode = current.searchParams.get('bbg_mode');
      if (mode === 'custom' || mode === 'ready') destination.searchParams.set('bbg_mode', mode);
      destination.searchParams.delete('page');
      link.href = destination.toString();
    };
  }

  if (!customElements.get('bbg-design-filter')) {
    customElements.define('bbg-design-filter', BbgDesignFilter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bbg-size-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bbg-size-guard')) {
    customElements.define('bbg-size-guard', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const form = this.closest('form');
        const details = this.closest('.product-details');
        if (!form || !details) return;
        const localize = () => {
          details.querySelectorAll('.po-dropdown-selected-option').forEach(el => {
            for (const node of el.childNodes) {
              if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '-- Please select --') node.textContent = this.dataset.placeholder;
            }
          });
          details.querySelectorAll('.po-dropdown-option[data-value="-- Please select --"] > span').forEach(el => {
            if (el.textContent !== this.dataset.placeholder) el.textContent = this.dataset.placeholder;
          });
        };
        localize();
        this.observer?.disconnect();
        this.observer = new MutationObserver(localize);
        this.observer.observe(details, { childList: true, subtree: true, characterData: true });
        const guard = event => {
          if (event.type === 'click' && !event.target.closest('button[type="submit"], input[type="submit"]')) return;
          const size = details.querySelector('select[key="po_Ringmaat"]');
          const selected = size && /^\d+(?:[,.]\d+)?$/.test(size.value.trim());
          const error = this.querySelector('[role="alert"]');
          if (selected) { error.hidden = true; return; }
          event.preventDefault();
          event.stopImmediatePropagation();
          error.hidden = false;
          const control = size?.parentElement.querySelector('.po-select-dropdown-thumbnail');
          (control || error).focus();
          (control || error).scrollIntoView({ block: 'center', behavior: 'instant' });
        };
        form.addEventListener('click', guard, { capture: true, signal: this.abort.signal });
        form.addEventListener('submit', guard, { capture: true, signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bbg-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bbg-size-guide')) {
    customElements.define('bbg-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.bbgInitialized) return;
        this.bbgInitialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-bbg-size-open]');
        if (!dialog || !trigger) return;
        trigger.addEventListener('click', () => {
          if (!dialog.open) {
            dialog.showModal();
            dialog.scrollTop = 0;
          }
        });
        this.querySelectorAll('[data-bbg-size-close]').forEach(button => {
          button.addEventListener('click', () => dialog.close());
        });
        dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
